/**
 * MOBY Buy Box — main interaction logic
 * Reads Liquid-provided values from data-* attributes on the section element.
 */
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.moby-buy-box[data-section-id]');
  if (!section) return;

  // Liquid values via data attributes
  const basePrice = parseInt(section.dataset.basePrice) || 0;
  const currency = section.dataset.currency || 'SEK';
  const locale = section.dataset.locale || 'en';
  const productId = section.dataset.productId;
  // subscribePriceFormatted will be computed after we know the real activeTierPrice
  let subscribePriceFormatted = '';
  const onetimePriceFormatted = section.dataset.onetimePriceFormatted || '';
  const mysteryRedirect = section.dataset.mysteryRedirect || '';

  const quantityInput = section.querySelector('#quantity-input');
  const sellingPlanInput = section.querySelector('#selling-plan-input');
  const btnPrice = section.querySelector('#btn-price');
  const form = section.querySelector('#moby-buy-box-form');
  const purchaseOptions = section.querySelector('#purchase-options');
  const sellingPlanSelect = section.querySelector('#selling-plan-select');
  const preorderQtyInput = section.querySelector('#preorder-qty-input');
  const isPreorderMode = form && form.dataset.isPreorder === 'true';

  const defaultSelected = purchaseOptions && purchaseOptions.querySelector('.moby-buy-box__option.is-selected');
  let currentQuantity = defaultSelected ? (parseInt(defaultSelected.dataset.quantity) || 1) : 1;
  let isSubscription = !!defaultSelected && defaultSelected.dataset.option !== 'onetime';
  let subscriptionDiscount = parseInt(section.dataset.savings1m) || 20;

  // Read initial prices from the default-selected option (set by Liquid after price calculation)
  const firstMonthPrice = defaultSelected ? (parseInt(defaultSelected.dataset.firstPrice) || basePrice) : basePrice;
  const ongoingPrice = firstMonthPrice;
  let activeTierPrice = defaultSelected ? (parseInt(defaultSelected.dataset.totalPrice) || (firstMonthPrice * currentQuantity)) : basePrice;
  let labelCart = null;

  async function refreshPurchaseLabel() {
    if (!window.MobyCart || !form || form.dataset.atcInFlight === 'true') return;
    labelCart = await window.MobyCart.get();
    updateButton();
  }
  document.addEventListener('cart:updated', function() { refreshPurchaseLabel().catch(function() {}); });
  document.addEventListener('cart:refresh', function() { refreshPurchaseLabel().catch(function() {}); });

  // Pre-populate the selling plan from the selected card on load.
  (function() {
    if (defaultSelected && sellingPlanInput) {
      var planId = defaultSelected.dataset.sellingPlanId;
      if (planId) sellingPlanInput.value = planId;
    }
  })();

  function formatMoney(cents) {
    const amount = cents / 100;

    // No decimals for kr currencies
    if (['SEK', 'NOK', 'DKK'].includes(currency)) {
      return amount.toLocaleString(locale || 'sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' kr';
    }

    // Whole-currency amounts on purchase offer displays.
    return amount.toLocaleString(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  // Now that formatMoney is defined, set the initial formatted price
  subscribePriceFormatted = formatMoney(activeTierPrice);

  function formatPerServing(cents) {
    return window.MobyPriceFormat.formatPerServing(cents, {
      currency: currency,
      locale: locale
    });
  }

  // Update per-serving displays
  function updatePerServing() {
    const subServing = section.querySelector('[data-serving-type="subscribe"]');
    const onetimeServing = section.querySelector('[data-serving-type="onetime"]');
    if (subServing) subServing.textContent = formatPerServing(firstMonthPrice);
    if (onetimeServing) onetimeServing.textContent = formatPerServing(basePrice);
  }
  updatePerServing();

  function updateButton() {
    let total;

    if (isPreorderMode) {
      total = basePrice * currentQuantity;
    } else if (isSubscription) {
      total = activeTierPrice;
    } else {
      total = basePrice * currentQuantity;
    }

    section.querySelectorAll("[data-risk-subscription-only]").forEach(function(item) {
      item.hidden = !isSubscription;
    });

    if (btnPrice) btnPrice.textContent = formatMoney(total);
    if (quantityInput) quantityInput.value = currentQuantity;

    // Update button text — always reads "Add to cart" (localized).
    // IM8-style: the verb is universal; the subscribe vs one-time
    // choice is made in the tier card above. We don't change the
    // CTA verb based on tier (was "Subscribe" / "Add to Cart" before,
    // which made the button feel inconsistent and slowed comprehension).
    const btnText = section.querySelector('#btn-text');
    if (btnText && !isPreorderMode) {
      var formEl = section.querySelector('form[action*="/cart/add"]');
      var fallback = (formEl && formEl.dataset.textAddToCart) || 'Add to cart';
      btnText.textContent = labelCart && window.MobyCart.purchaseLabel ? window.MobyCart.purchaseLabel(labelCart, formEl.querySelector('[name="id"]').value, sellingPlanInput && sellingPlanInput.value, fallback) || fallback : fallback;
    }
  }

  // Purchase option selection — multi-tier
  if (purchaseOptions) {
    const options = purchaseOptions.querySelectorAll('.moby-buy-box__option');

    options.forEach(option => {
      option.addEventListener('click', function(e) {
        if (e.target.closest('.moby-gift-journey__future')) return;
        const optionType = this.dataset.option;

        // Selecting a tier NEVER adds to cart — it only changes the
        // selection. Adding to cart requires an explicit click on the
        // add-to-cart button, so tier clicks (browsing) stay separate
        // from purchase intent.
        if (optionType === 'onetime') {
          // The one-time tier's quantity is always 1. The hidden
          // quantity input may still contain the previous tier quantity.
          // Reset it so one-time purchases always add a single box.
          if (quantityInput) quantityInput.value = 1;
        }

        // Update visual selection
        options.forEach(opt => opt.classList.remove('is-selected'));
        this.classList.add('is-selected');
        this.querySelector('input').checked = true;

        isSubscription = optionType !== 'onetime';

        // Set quantity from data attribute
        currentQuantity = parseInt(this.dataset.quantity) || 1;

        if (isSubscription) {
          // For monthly tier with dropdown, use the dropdown value
          if (optionType === 'subscribe' && sellingPlanSelect) {
            sellingPlanInput.value = sellingPlanSelect.value;
          } else {
            // For 3-month and 6-month, use the plan ID from data attribute
            var planId = this.dataset.sellingPlanId;
            if (sellingPlanInput && planId) {
              sellingPlanInput.value = planId;
            }
          }
          // Use total price from data attribute
          activeTierPrice = parseInt(this.dataset.totalPrice) || (firstMonthPrice * currentQuantity);
          subscribePriceFormatted = formatMoney(activeTierPrice);
        } else {
          if (sellingPlanInput) sellingPlanInput.value = '';
          activeTierPrice = basePrice;
        }

        updateButton();

        // Notify external components (sticky bar, etc.) of the tier change.
        // Map data-option ('subscribe-3' | 'subscribe' | 'onetime') to a
        // canonical plan key ('3m' | '1m' | 'onetime').
        var planKey = optionType === 'subscribe-3' ? '3m'
                    : optionType === 'subscribe'   ? '1m'
                    : 'onetime';
        document.dispatchEvent(new CustomEvent('mobyTierChange', {
          detail: {
            plan: planKey,
            price: activeTierPrice,
            unitPrice: parseInt(this.dataset.firstPrice) || basePrice,
            recurringPrice: parseInt(this.dataset.recurringPrice) || basePrice,
            quantity: currentQuantity,
            isSubscription: isSubscription
          }
        }));
      });
    });
  }

  // Selling plan dropdown change (only for monthly tier)
  // Updates: (1) hidden selling_plan input, (2) the benefit-list line that
  // displays the selected delivery frequency ("every 4 weeks" etc).
  function updateDeliveryFrequencyText() {
    if (!sellingPlanSelect) return;
    var target = section.querySelector('[data-delivery-frequency-text]');
    if (!target) return;
    var selected = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
    if (!selected) return;
    // selected.text is the Liquid-rendered label, e.g. "Deliver every 4 weeks".
    // Strip the leading "Deliver " so the line reads "1 box every 4 weeks".
    // Prefer the bare frequency from data-freq-label; the visible option text
    // carries a localized "Deliver"/"Leverans" prefix the regex can't cover.
    var label = (selected.dataset.freqLabel || (selected.text || '').replace(/^\s*deliver\s+/i, '')).toLowerCase();
    target.textContent = label;
  }

  if (sellingPlanSelect) {
    sellingPlanSelect.addEventListener('change', function() {
      // Only update if the monthly tier is currently selected
      var monthlyTier = purchaseOptions && purchaseOptions.querySelector('[data-option="subscribe"].is-selected');
      if (monthlyTier && sellingPlanInput) {
        sellingPlanInput.value = this.value;
        updateButton();
      }
      updateDeliveryFrequencyText();
    });
  }

  // Pre-order quantity picker
  if (preorderQtyInput) {
    preorderQtyInput.addEventListener('change', function() {
      currentQuantity = parseInt(this.value) || 1;
      updateButton();
    });
  }

  // Thumbnail gallery
  const thumbnails = section.querySelectorAll('.moby-buy-box__thumbnail');
  const dots = section.querySelectorAll('.moby-buy-box__dot');
  const mainImageContainer = section.querySelector('.moby-buy-box__main-image');
  const mainImage = section.querySelector('.moby-buy-box__image');

  function switchToImage(index) {
    if (index < 0 || index >= thumbnails.length) return;
    // Update thumbnails
    thumbnails.forEach(t => t.classList.remove('active'));
    thumbnails[index].classList.add('active');
    // Update dots
    dots.forEach(d => d.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');
    // Update main image with srcset from data attribute
    const thumb = thumbnails[index];
    const newImageUrl = thumb.dataset.imageUrl;
    if (mainImage && newImageUrl) {
      mainImage.srcset = thumb.dataset.srcset || '';
      mainImage.sizes = '(max-width: 749px) calc(100vw - 32px), (max-width: 1199px) 50vw, 600px';
      mainImage.src = newImageUrl;
      mainImage.alt = thumb.dataset.imageAlt || '';
    }
  }

  function getCurrentIndex() {
    const index = Array.from(thumbnails).findIndex(t => t.classList.contains('active'));
    return index >= 0 ? index : 0;
  }

  // Desktop stacked gallery (PDP): the stack replaces the single main
  // image at >=1024px, so thumbnails scroll to the image instead of
  // swapping the src. The featured buy box has no stack — everything
  // below no-ops there.
  const mediaStack = section.querySelector('.moby-buy-box__media-stack');
  const stackItems = mediaStack ? Array.from(mediaStack.querySelectorAll('.moby-buy-box__stack-item')) : [];
  function stackIsActive() {
    return stackItems.length > 0 && mediaStack.offsetParent !== null;
  }

  function setActiveThumb(index) {
    thumbnails.forEach(t => t.classList.remove('active'));
    if (thumbnails[index]) thumbnails[index].classList.add('active');
  }

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', function() {
      if (stackIsActive() && stackItems[index]) {
        setActiveThumb(index);
        stackItems[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        switchToImage(index);
      }
    });
  });

  // Keep the active thumbnail in sync while the user scrolls the stack.
  if (stackItems.length) {
    const stackObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        setActiveThumb(parseInt(entry.target.dataset.stackIndex, 10) || 0);
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    stackItems.forEach(item => stackObserver.observe(item));
  }

  // Smart sticky for the info column (stacked PDP only): when the panel
  // is taller than the viewport, lower the sticky top (negative is fine)
  // so the panel scrolls with the page until its bottom is visible, then
  // pins — the Wellina feel, no internal scrollbar.
  const stickyInfo = section.querySelector('.moby-buy-box__info');
  if (stackItems.length && stickyInfo) {
    const CHROME_OFFSET = 106; /* announcement 42 + nav 52 + 12 gap */
    const BOTTOM_GAP = 24;
    function updateInfoSticky() {
      const fits = stickyInfo.offsetHeight + CHROME_OFFSET + BOTTOM_GAP <= window.innerHeight;
      const top = fits ? CHROME_OFFSET : (window.innerHeight - stickyInfo.offsetHeight - BOTTOM_GAP);
      stickyInfo.style.setProperty('--moby-info-sticky-top', top + 'px');
    }
    updateInfoSticky();
    window.addEventListener('resize', updateInfoSticky);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateInfoSticky).observe(stickyInfo);
    }
  }

  // Touch swipe support for mobile
  if (mainImageContainer && thumbnails.length > 1) {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;

    mainImageContainer.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    mainImageContainer.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      const touchEndY = e.changedTouches[0].screenY;
      const diffX = touchStartX - touchEndX;
      const diffY = Math.abs(touchStartY - touchEndY);

      // Only trigger if horizontal swipe is greater than vertical (not a scroll)
      // and swipe distance is significant (> 50px)
      if (Math.abs(diffX) > 50 && Math.abs(diffX) > diffY) {
        const currentIndex = getCurrentIndex();
        if (diffX > 0) {
          // Swipe left - next image
          switchToImage(currentIndex + 1 < thumbnails.length ? currentIndex + 1 : 0);
        } else {
          // Swipe right - previous image
          switchToImage(currentIndex - 1 >= 0 ? currentIndex - 1 : thumbnails.length - 1);
        }
      }
    }, { passive: true });
  }

  // Dot click handlers
  dots.forEach((dot, index) => {
    dot.addEventListener('click', function() {
      switchToImage(index);
    });
  });

  // Arrow click handlers
  const prevArrow = section.querySelector('.moby-buy-box__arrow--prev');
  const nextArrow = section.querySelector('.moby-buy-box__arrow--next');

  if (prevArrow) {
    prevArrow.addEventListener('click', function(e) {
      e.stopPropagation();
      const currentIndex = getCurrentIndex();
      switchToImage(currentIndex - 1 >= 0 ? currentIndex - 1 : thumbnails.length - 1);
    });
  }

  if (nextArrow) {
    nextArrow.addEventListener('click', function(e) {
      e.stopPropagation();
      const currentIndex = getCurrentIndex();
      switchToImage(currentIndex + 1 < thumbnails.length ? currentIndex + 1 : 0);
    });
  }

  // Lightbox
  const lightbox = document.getElementById('moby-lightbox');
  if (lightbox) {
    const lbImage = lightbox.querySelector('.moby-lightbox__image');
    const lbThumbs = lightbox.querySelectorAll('.moby-lightbox__thumb');
    const lbCounter = lightbox.querySelector('.moby-lightbox__current');
    const lbPrev = lightbox.querySelector('.moby-lightbox__nav--prev');
    const lbNext = lightbox.querySelector('.moby-lightbox__nav--next');
    const lightboxTrigger = section.querySelector('[data-lightbox-trigger]');
    let lbIndex = 0;
    let lightboxOpener = null;
    let lightboxFocusModule = null;
    const lightboxFocusPromise = import('@theme/focus')
      .then(function(module) {
        lightboxFocusModule = module;
        return module;
      })
      .catch(function(error) {
        console.error('Lightbox focus module failed to load:', error);
        return null;
      });

    function setLightboxPageInert(isInert) {
      Array.from(document.body.children).forEach(function(element) {
        if (!(element instanceof HTMLElement) || element.contains(lightbox)) return;
        if (isInert) {
          if (!element.inert) {
            element.inert = true;
            element.dataset.mobyLightboxInert = 'true';
          }
        } else if (element.dataset.mobyLightboxInert === 'true') {
          element.inert = false;
          delete element.dataset.mobyLightboxInert;
        }
      });
    }

    async function openLightbox(index) {
      lightboxOpener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      lbIndex = index;
      updateLightboxImage();
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setLightboxPageInert(true);
      const module = lightboxFocusModule || await lightboxFocusPromise;
      if (lightbox.getAttribute('aria-hidden') !== 'false') return;
      var closeBtn = lightbox.querySelector('.moby-lightbox__close');
      if (module && typeof module.trapFocus === 'function') {
        module.trapFocus(lightbox, closeBtn || lightbox);
      } else if (closeBtn) {
        closeBtn.focus();
      }
    }

    function closeLightbox() {
      if (lightboxFocusModule && typeof lightboxFocusModule.removeTrapFocus === 'function') {
        lightboxFocusModule.removeTrapFocus();
      }
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setLightboxPageInert(false);
      if (lightboxOpener && document.contains(lightboxOpener)) lightboxOpener.focus();
      lightboxOpener = null;
    }

    function updateLightboxImage() {
      if (!lbThumbs[lbIndex]) return;
      const thumb = lbThumbs[lbIndex];
      lbImage.srcset = thumb.dataset.lightboxSrcset || '';
      lbImage.src = thumb.dataset.lightboxUrl;
      lbImage.alt = thumb.dataset.imageAlt || '';
      lbThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (lbCounter) lbCounter.textContent = lbIndex + 1;
    }

    // Open on the native keyboard- and pointer-accessible image trigger.
    if (lightboxTrigger) {
      lightboxTrigger.addEventListener('click', function() {
        openLightbox(getCurrentIndex());
      });
    }

    // Desktop stacked gallery: each stacked image opens the lightbox at
    // its own index.
    section.querySelectorAll('.moby-buy-box__stack-item').forEach(function(item) {
      item.addEventListener('click', function() {
        openLightbox(parseInt(item.dataset.stackIndex, 10) || 0);
      });
    });

    // Close when clicking anywhere outside the image, nav buttons, or thumbs
    lightbox.addEventListener('click', function(e) {
      if (e.target.closest('.moby-lightbox__image') || e.target.closest('.moby-lightbox__nav') || e.target.closest('.moby-lightbox__thumb')) return;
      closeLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (lightbox.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') { lbIndex = (lbIndex - 1 + lbThumbs.length) % lbThumbs.length; updateLightboxImage(); }
      if (e.key === 'ArrowRight') { lbIndex = (lbIndex + 1) % lbThumbs.length; updateLightboxImage(); }
    });

    // Nav arrows
    if (lbPrev) lbPrev.addEventListener('click', function() { lbIndex = (lbIndex - 1 + lbThumbs.length) % lbThumbs.length; updateLightboxImage(); });
    if (lbNext) lbNext.addEventListener('click', function() { lbIndex = (lbIndex + 1) % lbThumbs.length; updateLightboxImage(); });

    // Thumb clicks
    lbThumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { lbIndex = i; updateLightboxImage(); });
    });

    // Mobile swipe in lightbox
    let lbTouchStartX = 0;
    const lbImageWrapper = lightbox.querySelector('.moby-lightbox__image-wrapper');
    lbImageWrapper.addEventListener('touchstart', function(e) { lbTouchStartX = e.changedTouches[0].screenX; }, { passive: true });
    lbImageWrapper.addEventListener('touchend', function(e) {
      const diff = lbTouchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) { lbIndex = (lbIndex + 1) % lbThumbs.length; }
        else { lbIndex = (lbIndex - 1 + lbThumbs.length) % lbThumbs.length; }
        updateLightboxImage();
      }
    }, { passive: true });
  }

  let buttonResetTimer = null;

  function scheduleButtonReset(button, delay) {
    if (buttonResetTimer) clearTimeout(buttonResetTimer);
    buttonResetTimer = setTimeout(async function() {
      buttonResetTimer = null;
      if (form && form.dataset.atcInFlight === 'true') return;
      await checkStockAndUpdateButton();
      if (button && !button.disabled) {
        button.dataset.atcState = 'idle';
      }
    }, delay || 2000);
  }

  // Check stock availability and update button state
  async function checkStockAndUpdateButton() {
    if (!form) return;

    // Never touch the button while an add-to-cart is in flight — the
    // visibility/pageshow/cart:refresh triggers could otherwise re-enable
    // it mid-submit and open a double-submit window.
    if (form.dataset.atcInFlight === 'true') return;

    const errorButton = form.querySelector('button[type="submit"]');
    // Keep a rejection message readable until its scheduled reset; the
    // settle that follows a rejected add must not wipe it immediately.
    if (buttonResetTimer && errorButton && errorButton.dataset.atcState === 'error') return;

    const submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    const variantId = form.querySelector('input[name="id"]')?.value;
    // IM8-style: main ATC button shows only the verb ("Add to cart"),
    // regardless of subscription vs one-time. Price lives in the tier
    // card above + the sticky bar - never duplicated on the main ATC.
    // #btn-price kept hidden in DOM so existing JS hooks don't break.
    const atcLabel = (form.dataset.textAddToCart || 'Add to cart');
    const originalContent = '<span id="btn-text">' + atcLabel + '</span><span id="btn-price" hidden></span>';

    try {
      // Fetch cart state to check current quantities (shared cache)
      const cart = await window.MobyCart.get();
      labelCart = cart;

      // Get inventory info from form data attributes (Liquid provides this, API doesn't)
      const inventoryQty = parseInt(form.dataset.inventoryQuantity) || 0;
      const inventoryPolicy = form.dataset.inventoryPolicy || 'deny';

      // Count ALL items of this product in cart
      let currentQtyInCart = 0;
      cart.items.forEach(item => {
        if (String(item.product_id) === String(productId)) {
          currentQtyInCart += item.quantity;
        }
      });

      // Check if stock is already exhausted (for deny policy)
      if (inventoryPolicy === 'deny' && currentQtyInCart >= inventoryQty) {
        submitBtn.disabled = true;
        submitBtn.dataset.atcState = 'stock';
        submitBtn.innerHTML = '<span>' + (form.dataset.textNoStock || 'No more stock available') + '</span>';
        return; // Exit early - no more stock
      }

      // If we get here, stock is available - enable button
      submitBtn.disabled = false;
      updateButton();
      // Restore by explicit state, never by matching English UI text. This
      // keeps Swedish and every other locale on the same lifecycle.
      if (['stock', 'success', 'error'].includes(submitBtn.dataset.atcState)) {
        submitBtn.innerHTML = originalContent;
        submitBtn.dataset.atcState = 'idle';
        updateButton(); // Update price display
      }
    } catch (error) {
      console.error('Stock check error:', error);
    }
  }

  // Run stock check on page load
  checkStockAndUpdateButton();

  // Also run when page becomes visible again (returning from another tab/page)
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') {
      checkStockAndUpdateButton();
    }
  });

  // Handle browser back/forward navigation (bfcache)
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      checkStockAndUpdateButton();
    }
  });

  // Listen for cart updates (e.g., from cart drawer)
  document.addEventListener('cart:refresh', checkStockAndUpdateButton);
  document.addEventListener('cart:updated', checkStockAndUpdateButton);

  // Inventory check on the single fresh cart read taken by addPaidLine. It
  // counts every line of this product, including a subscription line that a
  // switch will replace: Shopify still sees both while the paid add runs.
  function validateStock(requestedQty) {
    return function(cart) {
      const inventoryQty = parseInt(form.dataset.inventoryQuantity) || 0;
      const inventoryPolicy = form.dataset.inventoryPolicy || 'deny';
      if (inventoryPolicy !== 'deny') return;
      let currentQtyInCart = 0;
      cart.items.forEach(item => {
        if (String(item.product_id) === String(productId)) currentQtyInCart += item.quantity;
      });
      if (currentQtyInCart + requestedQty > inventoryQty) {
        const remaining = inventoryQty - currentQtyInCart;
        if (remaining <= 0) throw new Error(form.dataset.textNoStock || 'No more stock available');
        throw new Error((form.dataset.textOnlyX || 'Only COUNT_PLACEHOLDER more available').replace('COUNT_PLACEHOLDER', remaining));
      }
    };
  }

  // AJAX Add to Cart - prevents redirect, opens drawer instead
  if (form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Re-entry guard for the whole in-flight window. The disabled state
      // on the button doesn't block form.requestSubmit() (used by the
      // one-time tier card and the sticky bar), so on a slow connection a
      // second tap could otherwise fire a second /cart/add.js.
      if (form.dataset.atcInFlight === 'true') return;
      form.dataset.atcInFlight = 'true';

      const submitBtn = form.querySelector('button[type="submit"]');

      // Show loading state
      submitBtn.disabled = true;
      submitBtn.dataset.atcState = 'loading';
      const addingText = form.dataset.textAdding || 'Adding...';
      const stopPending = window.MobyCart.whilePending(function(text) {
        if (form.dataset.atcInFlight === 'true') submitBtn.innerHTML = '<span>' + window.MobyCart.pendingLabel(text) + '</span>';
      }, addingText);

      try {
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const requestedQty = parseInt(formData.get('quantity')) || 1;

        const mainItem = {
          id: variantId,
          quantity: requestedQty
        };

        // Add selling plan if subscription is selected
        let sellingPlan = formData.get('selling_plan');
        if ((!sellingPlan || sellingPlan === '') && isSubscription && sellingPlanSelect) {
          sellingPlan = sellingPlanSelect.value;
        }
        if (sellingPlan && sellingPlan !== '') {
          mainItem.selling_plan = sellingPlan;
          mainItem.properties = { _moby_offer: "calendar-2026-10" };
        }

        // The paid line is submitted alone. Gifts, the first-order code and
        // the theme add_to_cart event follow from the coordinator's settle.
        await window.MobyCart.addPaidLine(mainItem, { validate: validateStock(requestedQty) });

        // Shopify accepted the paid line: open the drawer right away. It
        // shows the settling cart with checkout gated until it is final.
        stopPending();
        delete form.dataset.atcInFlight;
        submitBtn.innerHTML = '<span>' + (form.dataset.textAdded || 'Added!') + '</span>';
        submitBtn.dataset.atcState = 'success';
        scheduleButtonReset(submitBtn, 1500);
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
      } catch (error) {
        stopPending();
        delete form.dataset.atcInFlight;
        if (error.mobyPaidAddCommitted) {
          console.warn('Post-add enrichment failed:', error);
          if (window.openCartDrawer) window.openCartDrawer();
          submitBtn.innerHTML = '<span>' + (form.dataset.textAdded || 'Added!') + '</span>';
          submitBtn.dataset.atcState = 'success';
          scheduleButtonReset(submitBtn, 1500);
          return;
        }
        console.error('Add to cart error:', error);
        const errorText = error.message.length < 50 ? error.message : 'Error - Try Again';
        submitBtn.innerHTML = '<span>' + errorText + '</span>';
        submitBtn.dataset.atcState = 'error';
        scheduleButtonReset(submitBtn, 2000);
      }
    });
  }

  // Initial update
  updateButton();
  refreshPurchaseLabel().catch(function() {});

  // ── Mystery Discount: activate → signup → redirect ──
  (function() {
    var activateWrap = document.getElementById('mystery-activate');
    var activateBtn = document.getElementById('mystery-activate-btn');
    var signupWrap = document.getElementById('mystery-signup');
    var confirmedWrap = document.getElementById('mystery-confirmed');
    var mysteryForm = document.getElementById('mystery-form');
    if (!activateBtn) return;

    var discountUrl = mysteryRedirect;

    // If already revealed (localStorage), skip straight to confirmed state
    if (localStorage.getItem('moby-mystery-discount-revealed')) {
      activateWrap.style.display = 'none';
      signupWrap.style.display = 'none';
      confirmedWrap.style.display = '';
      return;
    }

    // Step 1: Click activate → show newsletter form
    activateBtn.addEventListener('click', function() {
      activateWrap.style.display = 'none';
      signupWrap.style.display = '';
      var emailInput = signupWrap.querySelector('input[type="email"]');
      if (emailInput) emailInput.focus();
    });

    // Step 2: Submit form → save email, show confirmed, redirect
    if (mysteryForm) {
      mysteryForm.addEventListener('submit', function(e) {
        e.preventDefault();

        var emailInput = mysteryForm.querySelector('input[type="email"]');
        var checkbox = mysteryForm.querySelector('input[type="checkbox"]');

        if (!emailInput.value || !emailInput.validity.valid) {
          emailInput.focus();
          return;
        }
        if (!checkbox.checked) {
          checkbox.focus();
          return;
        }

        var submitBtn = mysteryForm.querySelector('.moby-mystery__submit-btn');
        submitBtn.disabled = true;
        submitBtn.textContent = '...';

        // Show confirmed state immediately (optimistic)
        signupWrap.style.display = 'none';
        confirmedWrap.style.display = '';
        localStorage.setItem('moby-mystery-discount-revealed', 'true');

        // Submit email + apply discount in background
        var formData = new FormData(mysteryForm);
        fetch(mysteryForm.action || '/contact', {
          method: 'POST',
          body: formData
        }).catch(function(err) { console.error('Mystery discount signup error:', err); });
        fetch(discountUrl, { redirect: 'follow' }).catch(function() {});
      });
    }
  })();
});

/* Social proof video cards — first-frame poster via #t=0.1, lazy play */
(function() {
  var cards = document.querySelectorAll('.moby-buy-box__social-video-card');
  if (!cards.length) return;
  var shouldPrimeMobilePoster = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

  function setupVideoPoster(card, video) {
    if (!video || video.dataset.posterSetup === 'true') return;
    video.dataset.posterSetup = 'true';
    var posterTime = parseFloat(video.dataset.posterFrameTime || '0.1');
    var posterImage = document.createElement('img');
    posterImage.className = 'moby-buy-box__social-video-poster';
    posterImage.alt = '';
    posterImage.setAttribute('aria-hidden', 'true');
    posterImage.decoding = 'async';

    posterImage.addEventListener('error', function() {
      /* Fall back to the video's native poster instead of leaving the
         dark card background visible if the overlay image cannot load. */
      card.classList.remove('has-poster');
      posterImage.remove();
    }, { once: true });

    function applyPoster(dataUrl) {
      if (!dataUrl || card.classList.contains('has-poster')) return;
      posterImage.src = dataUrl;
      video.setAttribute('poster', dataUrl);
      card.insertBefore(posterImage, video);
      card.classList.add('has-poster');
    }

    /* Shopify renders a valid poster URL in Liquid for the configured
       social videos. Mirror it into the dedicated overlay image that the
       CSS expects; previously we only added `has-poster`, which hid the
       video and exposed the black card background on mobile. */
    var nativePoster = video.getAttribute('poster');
    if (nativePoster) {
      applyPoster(nativePoster);
      return;
    }

    var captureAttempts = 0;
    var MAX_CAPTURE_ATTEMPTS = 8;

    /* Returns true only if the canvas has actual pixel content (not all-black).
       Some browsers fire loadeddata/seeked before the first frame is decoded,
       so a successful drawImage() can still produce a black canvas. We sample
       several pixels and require at least one to be non-black. */
    function canvasIsNonBlack(context, width, height) {
      try {
        var samples = [
          [Math.floor(width * 0.5), Math.floor(height * 0.5)],
          [Math.floor(width * 0.25), Math.floor(height * 0.25)],
          [Math.floor(width * 0.75), Math.floor(height * 0.75)],
          [Math.floor(width * 0.5), Math.floor(height * 0.1)],
          [Math.floor(width * 0.5), Math.floor(height * 0.9)]
        ];
        for (var i = 0; i < samples.length; i++) {
          var pixel = context.getImageData(samples[i][0], samples[i][1], 1, 1).data;
          /* Treat anything brighter than ~rgb(8,8,8) as real content. */
          if (pixel[0] > 8 || pixel[1] > 8 || pixel[2] > 8) return true;
        }
        return false;
      } catch (error) {
        /* If we can't read pixels (e.g. tainted canvas), accept the capture
           rather than block forever — better than no poster. */
        return true;
      }
    }

    function capturePoster() {
      if (!video.videoWidth || !video.videoHeight) return false;

      try {
        var canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        var context = canvas.getContext('2d');
        if (!context) return false;

        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        if (!canvasIsNonBlack(context, canvas.width, canvas.height)) {
          return false;
        }

        applyPoster(canvas.toDataURL('image/jpeg', 0.82));
        return true;
      } catch (error) {
        return false;
      }
    }

    function captureAndRestore() {
      if (card.classList.contains('has-poster')) return;
      var captured = capturePoster();
      if (captured && !card.classList.contains('playing')) {
        video.pause();
        video.muted = true;
        return;
      }
      /* Capture failed (likely undecoded black frame). Retry on the next
         decoded frame using requestVideoFrameCallback when available, else
         a short rAF/timeout. Cap retries so we don't loop forever on
         genuinely all-black videos. */
      if (captureAttempts >= MAX_CAPTURE_ATTEMPTS) return;
      captureAttempts++;
      scheduleRetry();
    }

    function scheduleRetry() {
      if (typeof video.requestVideoFrameCallback === 'function') {
        video.requestVideoFrameCallback(captureAndRestore);
      } else if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function() {
          /* Two rAFs out — gives the decoder time to emit a real frame. */
          window.requestAnimationFrame(captureAndRestore);
        });
      } else {
        setTimeout(captureAndRestore, 80);
      }
    }

    function seekToPosterFrame() {
      if (card.classList.contains('has-poster')) return;
      if (!Number.isFinite(posterTime)) posterTime = 0.1;

      try {
        var targetTime = posterTime;
        if (Number.isFinite(video.duration) && video.duration > 0 && targetTime >= video.duration) {
          targetTime = 0;
        }
        if (Math.abs(video.currentTime - targetTime) > 0.03) {
          video.currentTime = targetTime;
        } else {
          scheduleRetry();
        }
      } catch (error) {
        scheduleRetry();
      }
    }

    video.addEventListener('loadedmetadata', seekToPosterFrame, { once: true });
    video.addEventListener('seeked', scheduleRetry, { once: true });
    video.addEventListener('canplay', scheduleRetry, { once: true });

    if (video.readyState >= 2) {
      scheduleRetry();
    } else if (video.readyState >= 1) {
      seekToPosterFrame();
    } else {
      video.load();
    }

    if (shouldPrimeMobilePoster) {
      setTimeout(function() {
        if (card.classList.contains('has-poster') || card.classList.contains('playing')) return;
        var playPromise = video.play();
        if (!playPromise || typeof playPromise.then !== 'function') return;
        playPromise
          .then(function() {
            scheduleRetry();
          })
          .catch(function() {});
      }, 900);
    }
  }

  /* Defer poster setup (which triggers video downloads via load()/play())
     until the card approaches the viewport. The social videos sit below the
     fold, and the heaviest is ~17 MB — priming all three at page load
     saturates mobile bandwidth and wrecks PDP load time on paid traffic. */
  function observePosterSetup(card, video) {
    if (!('IntersectionObserver' in window)) {
      setupVideoPoster(card, video);
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        setupVideoPoster(card, video);
      });
    }, { rootMargin: '200px 0px' });
    observer.observe(card);
  }

  /* Play/pause controls */
  cards.forEach(function(card) {
    var video = card.querySelector('video');
    var playBtn = card.querySelector('.moby-buy-box__social-video-play');
    if (!video || !playBtn) return;
    observePosterSetup(card, video);

    function togglePlay(e) {
      e.preventDefault();
      e.stopPropagation();
      setupVideoPoster(card, video);
      if (video.paused) {
        /* Pause all other videos first */
        document.querySelectorAll('.moby-buy-box__social-video-card.playing').forEach(function(other) {
          if (other !== card) {
            other.classList.remove('playing');
            var otherVideo = other.querySelector('video');
            otherVideo.pause();
            otherVideo.muted = true;
          }
        });
        video.muted = false;
        video.play().catch(function() {});
        card.classList.add('playing');
      } else {
        video.pause();
        video.muted = true;
        card.classList.remove('playing');
      }
    }

    playBtn.addEventListener('click', togglePlay);
    card.addEventListener('click', function(e) {
      if (e.target === playBtn || playBtn.contains(e.target)) return;
      togglePlay(e);
    });
  });
})();
